export const ephemerisFullDatesCsv = `Date,RA,Dec,Tmag,SkyMotion,SkyMotPA,RelVelAng
2022-03-02T00:00Z,299.69389,1.74832,16.807,0.4680304,43.692015,-51.88292
2022-03-03T00:00Z,299.82291,1.88428,16.793,0.4688305,43.06244,-52.19538
2022-03-04T00:00Z,299.95064,2.0219,16.78,0.4696297,42.422995,-52.50248
2022-03-05T00:00Z,300.07705,2.16119,16.766,0.4704322,41.773758,-52.80403
2022-03-06T00:00Z,300.20208,2.30215,16.751,0.4712423,41.114787,-53.09983
2022-03-07T00:00Z,300.32569,2.44479,16.737,0.4720644,40.446108,-53.38974
2022-03-08T00:00Z,300.44784,2.58913,16.723,0.4729029,39.767717,-53.67364
2022-03-09T00:00Z,300.5685,2.73518,16.708,0.4737618,39.079588,-53.95141
2022-03-10T00:00Z,300.6876,2.88294,16.694,0.4746453,38.381678,-54.22295
2022-03-11T00:00Z,300.80513,3.03244,16.679,0.4755573,37.673943,-54.48818
2022-03-12T00:00Z,300.92102,3.18368,16.664,0.476502,36.956336,-54.74699
2022-03-13T00:00Z,301.03524,3.33667,16.649,0.4774833,36.228816,-54.9993
2022-03-14T00:00Z,301.14774,3.49144,16.634,0.4785054,35.491341,-55.24501
2022-03-15T00:00Z,301.25849,3.64799,16.618,0.4795728,34.743865,-55.48405
2022-03-16T00:00Z,301.36743,3.80634,16.603,0.4806896,33.986326,-55.71632
2022-03-17T00:00Z,301.47453,3.9665,16.587,0.4818603,33.218633,-55.94177
2022-03-18T00:00Z,301.57973,4.12849,16.572,0.4830889,32.440655,-56.16033
2022-03-19T00:00Z,301.68299,4.29233,16.556,0.4843794,31.652208,-56.37199
2022-03-20T00:00Z,301.78427,4.45803,16.54,0.4857351,30.853062,-56.5767
2022-03-21T00:00Z,301.8835,4.62561,16.524,0.4871591,30.042952,-56.77447
2022-03-22T00:00Z,301.98065,4.79509,16.507,0.4886539,29.221602,-56.96527
2022-03-23T00:00Z,302.07565,4.96649,16.491,0.4902219,28.388756,-57.14908
2022-03-24T00:00Z,302.16845,5.13982,16.474,0.4918652,27.544212,-57.32584
2022-03-25T00:00Z,302.259,5.3151,16.458,0.4935862,26.687839,-57.49548
2022-03-26T00:00Z,302.34722,5.49235,16.441,0.4953872,25.819603,-57.65788
2022-03-27T00:00Z,302.43306,5.67158,16.424,0.4972714,24.939568,-57.81291
2022-03-28T00:00Z,302.51645,5.85282,16.407,0.4992421,24.047901,-57.96037
2022-03-29T00:00Z,302.59734,6.03607,16.39,0.5013034,23.144871,-58.1001
2022-03-30T00:00Z,302.67564,6.22135,16.372,0.5034598,22.230835,-58.23186
2022-03-31T00:00Z,302.7513,6.40868,16.355,0.5057166,21.306224,-58.35544
2022-04-01T00:00Z,302.82426,6.59806,16.337,0.5080795,20.371525,-58.47061
2022-04-02T00:00Z,302.89444,6.78952,16.32,0.5105546,19.42725,-58.57716
2022-04-03T00:00Z,302.96177,6.98306,16.302,0.5131483,18.473924,-58.67488
2022-04-04T00:00Z,303.0262,7.17871,16.284,0.515867,17.512063,-58.76358
2022-04-05T00:00Z,303.08766,7.37646,16.266,0.5187174,16.54217,-58.84308
2022-04-06T00:00Z,303.14606,7.57635,16.247,0.5217059,15.564735,-58.91322
2022-04-07T00:00Z,303.20136,7.77838,16.229,0.5248388,14.580239,-58.97385
2022-04-08T00:00Z,303.25348,7.98257,16.211,0.5281223,13.589162,-59.02484
2022-04-09T00:00Z,303.30235,8.18893,16.192,0.5315628,12.591987,-59.06606
2022-04-10T00:00Z,303.3479,8.39749,16.173,0.5351664,11.589208,-59.09738
2022-04-11T00:00Z,303.39005,8.60825,16.154,0.5389392,10.581326,-59.11868
2022-04-12T00:00Z,303.42874,8.82123,16.135,0.5428875,9.5688429,-59.12985
2022-04-13T00:00Z,303.46389,9.03645,16.116,0.5470177,8.5522478,-59.13079
2022-04-14T00:00Z,303.49542,9.25393,16.097,0.551336,7.5319986,-59.1214
2022-04-15T00:00Z,303.52325,9.47368,16.078,0.5558487,6.5084967,-59.10161
2022-04-16T00:00Z,303.54731,9.69572,16.058,0.5605621,5.4820651,-59.07132
2022-04-17T00:00Z,303.56752,9.92007,16.038,0.5654818,4.4529385,-59.0305
2022-04-18T00:00Z,303.58378,10.14675,16.019,0.570613,3.4212726,-58.97908
2022-04-19T00:00Z,303.59601,10.37577,15.999,0.5759603,2.3871783,-58.91702
2022-04-20T00:00Z,303.60412,10.60715,15.979,0.5815273,1.3507735,-58.84428
2022-04-21T00:00Z,303.608,10.84091,15.959,0.5873172,0.3122363,-58.76079
2022-04-22T00:00Z,303.60757,11.07707,15.939,0.5933328,359.27184,-58.66649
2022-04-23T00:00Z,303.6027,11.31563,15.918,0.5995767,358.22998,-58.56131
2022-04-24T00:00Z,303.59331,11.5566,15.898,0.6060513,357.18716,-58.44516
2022-04-25T00:00Z,303.57928,11.8,15.877,0.612759,356.14395,-58.31797
2022-04-26T00:00Z,303.56051,12.04583,15.857,0.6197025,355.101,-58.17966
2022-04-27T00:00Z,303.53688,12.2941,15.836,0.6268844,354.05901,-58.03015
2022-04-28T00:00Z,303.50828,12.54481,15.815,0.6343072,353.01867,-57.86937
2022-04-29T00:00Z,303.47459,12.79797,15.794,0.6419736,351.9807,-57.69728
2022-04-30T00:00Z,303.43572,13.05357,15.773,0.6498861,350.94577,-57.51383
2022-05-01T00:00Z,303.39153,13.31163,15.752,0.6580472,349.91456,-57.319
2022-05-02T00:00Z,303.34191,13.57212,15.73,0.6664595,348.88767,-57.11274
2022-05-03T00:00Z,303.28676,13.83506,15.709,0.675125,347.86566,-56.89507
2022-05-04T00:00Z,303.22594,14.10044,15.688,0.684046,346.84904,-56.66597
2022-05-05T00:00Z,303.15935,14.36825,15.666,0.6932242,345.83826,-56.42546
2022-05-06T00:00Z,303.08685,14.63849,15.644,0.7026611,344.83372,-56.17354
2022-05-07T00:00Z,303.00833,14.91115,15.623,0.7123579,343.83576,-55.91024
2022-05-08T00:00Z,302.92366,15.18622,15.601,0.7223155,342.8447,-55.63559
2022-05-09T00:00Z,302.83272,15.46368,15.579,0.7325346,341.86081,-55.34962
2022-05-10T00:00Z,302.73537,15.74353,15.557,0.7430157,340.8843,-55.05236
2022-05-11T00:00Z,302.6315,16.02576,15.535,0.7537592,339.91538,-54.74385
2022-05-12T00:00Z,302.52096,16.31033,15.513,0.7647656,338.95415,-54.42413
2022-05-13T00:00Z,302.40362,16.59724,15.491,0.7760352,338.00067,-54.09323
2022-05-14T00:00Z,302.27935,16.88647,15.468,0.7875684,337.05486,-53.75117
2022-05-15T00:00Z,302.14799,17.17798,15.446,0.7993657,336.11657,-53.39797
2022-05-16T00:00Z,302.00942,17.47176,15.424,0.8114266,335.18548,-53.03365
2022-05-17T00:00Z,301.86347,17.76778,15.401,0.8237498,334.26123,-52.6582
2022-05-18T00:00Z,301.71,18.06599,15.379,0.8363324,333.3434,-52.27163
2022-05-19T00:00Z,301.54885,18.36637,15.357,0.8491696,332.43159,-51.87392
2022-05-20T00:00Z,301.37985,18.66887,15.334,0.8622549,331.52549,-51.4651
2022-05-21T00:00Z,301.20284,18.97343,15.312,0.8755802,330.62489,-51.04519
2022-05-22T00:00Z,301.01766,19.27999,15.289,0.8891366,329.72969,-50.61424
2022-05-23T00:00Z,300.82414,19.58851,15.266,0.9029141,328.83983,-50.17231
2022-05-24T00:00Z,300.62212,19.8989,15.244,0.9169024,327.95532,-49.71946
2022-05-25T00:00Z,300.41143,20.21108,15.221,0.9310908,327.07615,-49.25578
2022-05-26T00:00Z,300.1919,20.52498,15.199,0.9454683,326.20233,-48.78136
2022-05-27T00:00Z,299.96338,20.84051,15.176,0.9600234,325.33385,-48.29631
2022-05-28T00:00Z,299.72571,21.15757,15.153,0.9747444,324.47066,-47.80071
2022-05-29T00:00Z,299.47871,21.47607,15.131,0.9896189,323.6127,-47.29469
2022-05-30T00:00Z,299.22225,21.79589,15.108,1.0046344,322.75988,-46.77835
2022-05-31T00:00Z,298.95617,22.11692,15.086,1.0197778,321.91209,-46.25182
2022-06-01T00:00Z,298.68031,22.43904,15.063,1.0350355,321.06918,-45.71522
2022-06-02T00:00Z,298.39453,22.76213,15.041,1.0503936,320.23097,-45.16867
2022-06-03T00:00Z,298.09867,23.08606,15.018,1.0658377,319.39726,-44.61229
2022-06-04T00:00Z,297.79261,23.41068,14.996,1.0813528,318.56783,-44.04622
2022-06-05T00:00Z,297.47621,23.73584,14.974,1.0969236,317.74244,-43.47058
2022-06-06T00:00Z,297.14932,24.06141,14.951,1.1125341,316.92082,-42.88551
2022-06-07T00:00Z,296.81183,24.38721,14.929,1.1281683,316.10269,-42.29115
2022-06-08T00:00Z,296.4636,24.71308,14.907,1.1438096,315.28777,-41.68762
2022-06-09T00:00Z,296.10453,25.03885,14.885,1.1594415,314.47573,-41.07508
2022-06-10T00:00Z,295.7345,25.36433,14.863,1.1750478,313.66623,-40.45363
2022-06-11T00:00Z,295.3534,25.68935,14.841,1.1906121,312.85886,-39.8234
2022-06-12T00:00Z,294.96113,26.0137,14.82,1.2061183,312.05315,-39.18449
2022-06-13T00:00Z,294.55761,26.33718,14.798,1.2215498,311.24858,-38.53696
2022-06-14T00:00Z,294.14273,26.65959,14.777,1.2368887,310.44452,-37.88087
2022-06-15T00:00Z,293.71642,26.98071,14.755,1.2521148,309.64034,-37.21629
2022-06-16T00:00Z,293.27861,27.30031,14.734,1.2672049,308.83541,-36.54326
2022-06-17T00:00Z,292.82924,27.61814,14.713,1.2821326,308.02918,-35.86189
2022-06-18T00:00Z,292.36825,27.93396,14.692,1.2968688,307.22121,-35.17232
2022-06-19T00:00Z,291.89561,28.24752,14.672,1.3113825,306.41116,-34.47475
2022-06-20T00:00Z,291.41131,28.55854,14.651,1.3256423,305.5988,-33.7694
2022-06-21T00:00Z,290.91534,28.86675,14.631,1.3396168,304.78394,-33.05654
2022-06-22T00:00Z,290.40774,29.17187,14.611,1.3532751,303.96646,-32.33644
2022-06-23T00:00Z,289.88854,29.47361,14.591,1.3665869,303.14625,-31.60942
2022-06-24T00:00Z,289.35781,29.77168,14.571,1.3795227,302.32322,-30.87578
2022-06-25T00:00Z,288.81563,30.0658,14.552,1.3920537,301.49728,-30.13584
2022-06-26T00:00Z,288.26213,30.35566,14.533,1.4041517,300.66838,-29.38992
2022-06-27T00:00Z,287.69743,30.64096,14.514,1.4157894,299.83644,-28.63836
2022-06-28T00:00Z,287.1217,30.92142,14.495,1.4269402,299.00144,-27.88151
2022-06-29T00:00Z,286.53512,31.19672,14.476,1.4375787,298.16333,-27.11972
2022-06-30T00:00Z,285.9379,31.46657,14.458,1.4476804,297.3221,-26.35334
2022-07-01T00:00Z,285.33027,31.73069,14.44,1.4572222,296.47777,-25.58276
2022-07-02T00:00Z,284.7125,31.98877,14.422,1.4661822,295.63033,-24.80832
2022-07-03T00:00Z,284.08487,32.24055,14.405,1.4745401,294.77984,-24.03042
2022-07-04T00:00Z,283.4477,32.48573,14.388,1.4822772,293.92632,-23.24943
2022-07-05T00:00Z,282.80132,32.72405,14.371,1.4893764,293.06984,-22.46572
2022-07-06T00:00Z,282.14609,32.95525,14.354,1.4958227,292.21046,-21.67969
2022-07-07T00:00Z,281.4824,33.17907,14.338,1.5016029,291.34826,-20.89169
2022-07-08T00:00Z,280.81066,33.39527,14.322,1.5067063,290.48331,-20.1021
2022-07-09T00:00Z,280.13129,33.60362,14.306,1.5111245,289.61567,-19.31126
2022-07-10T00:00Z,279.44474,33.8039,14.291,1.514851,288.74537,-18.51949
2022-07-11T00:00Z,278.75149,33.9959,14.276,1.5178811,287.8724,-17.72709
2022-07-12T00:00Z,278.05202,34.17943,14.261,1.5202105,286.99668,-16.93431
2022-07-13T00:00Z,277.34683,34.35431,14.246,1.5218346,286.11813,-16.1414
2022-07-14T00:00Z,276.63645,34.52035,14.232,1.5227468,285.23665,-15.34861
2022-07-15T00:00Z,275.9214,34.67742,14.218,1.5229391,284.35217,-14.55621
2022-07-16T00:00Z,275.20225,34.82535,14.205,1.5224019,283.46473,-13.76454
2022-07-17T00:00Z,274.47957,34.96401,14.191,1.5211262,282.57448,-12.97399
2022-07-18T00:00Z,273.75395,35.09331,14.178,1.5191043,281.68166,-12.18501
2022-07-19T00:00Z,273.026,35.21313,14.166,1.5163317,280.78659,-11.39807
2022-07-20T00:00Z,272.29632,35.3234,14.153,1.5128069,279.88967,-10.61368
2022-07-21T00:00Z,271.56556,35.42407,14.141,1.5085318,278.9913,-9.832346
2022-07-22T00:00Z,270.83433,35.5151,14.129,1.5035115,278.09191,-9.054583
2022-07-23T00:00Z,270.10328,35.59648,14.118,1.4977537,277.19192,-8.280892
2022-07-24T00:00Z,269.37303,35.66822,14.106,1.4912687,276.29176,-7.511773
2022-07-25T00:00Z,268.64424,35.73034,14.096,1.4840687,275.39186,-6.747719
2022-07-26T00:00Z,267.91751,35.78289,14.085,1.4761683,274.49264,-5.989224
2022-07-27T00:00Z,267.19348,35.82594,14.074,1.4675838,273.59452,-5.236776
2022-07-28T00:00Z,266.47275,35.85959,14.064,1.4583335,272.69791,-4.490859
2022-07-29T00:00Z,265.75592,35.88395,14.054,1.4484377,271.80322,-3.751955
2022-07-30T00:00Z,265.04357,35.89913,14.045,1.4379183,270.91085,-3.020535
2022-07-31T00:00Z,264.33626,35.90529,14.035,1.4267989,270.02119,-2.297065
2022-08-01T00:00Z,263.63454,35.90259,14.026,1.4151048,269.13459,-1.581994
2022-08-02T00:00Z,262.93893,35.89121,14.017,1.4028627,268.2514,-0.87576
2022-08-03T00:00Z,262.24992,35.87134,14.009,1.3901005,267.3719,-0.178781
2022-08-04T00:00Z,261.56799,35.84318,14.0,1.3768471,266.49637,0.5085456
2022-08-05T00:00Z,260.89359,35.80696,13.992,1.3631324,265.62502,1.185848
2022-08-06T00:00Z,260.22713,35.7629,13.984,1.3489869,264.75801,1.8527848
2022-08-07T00:00Z,259.56901,35.71123,13.976,1.3344414,263.89542,2.5090513
2022-08-08T00:00Z,258.91958,35.6522,13.968,1.3195259,263.03724,3.1543823
2022-08-09T00:00Z,258.27919,35.58605,13.961,1.3042694,262.18336,3.78855
2022-08-10T00:00Z,257.64814,35.51303,13.953,1.2886985,261.33359,4.4113515
2022-08-11T00:00Z,257.02671,35.4334,13.946,1.2728369,260.48764,5.0225853
2022-08-12T00:00Z,256.41516,35.34741,13.939,1.2567046,259.64523,5.6220201
2022-08-13T00:00Z,255.81373,35.25531,13.932,1.2403193,258.80607,6.2093656
2022-08-14T00:00Z,255.22264,35.15735,13.925,1.2236969,257.96997,6.7842572
2022-08-15T00:00Z,254.64208,35.05379,13.919,1.2068531,257.1368,7.3462568
2022-08-16T00:00Z,254.07223,34.94488,13.912,1.1898042,256.30654,7.8948682
2022-08-17T00:00Z,253.51326,34.83088,13.905,1.1725679,255.47922,8.4295571
2022-08-18T00:00Z,252.96529,34.71204,13.899,1.1551632,254.65488,8.9497673
2022-08-19T00:00Z,252.42843,34.58864,13.893,1.1376097,253.83356,9.4549318
2022-08-20T00:00Z,251.9028,34.46092,13.886,1.1199277,253.01532,9.9444753
2022-08-21T00:00Z,251.38845,34.32914,13.88,1.1021373,252.20017,10.417814
2022-08-22T00:00Z,250.88545,34.19355,13.874,1.0842586,251.38812,10.87435
2022-08-23T00:00Z,250.39382,34.05441,13.867,1.0663112,250.57915,11.313467
2022-08-24T00:00Z,249.91359,33.91197,13.861,1.0483144,249.77326,11.734527
2022-08-25T00:00Z,249.44476,33.76647,13.855,1.030287,248.97043,12.136865
2022-08-26T00:00Z,248.9873,33.61815,13.849,1.0122475,248.17065,12.519787
2022-08-27T00:00Z,248.54117,33.46726,13.843,0.9942141,247.37392,12.88257
2022-08-28T00:00Z,248.10634,33.31401,13.837,0.9762049,246.58022,13.224467
2022-08-29T00:00Z,247.68273,33.15865,13.83,0.9582376,245.78954,13.544707
2022-08-30T00:00Z,247.27027,33.00139,13.824,0.94033,245.00184,13.842496
2022-08-31T00:00Z,246.86886,32.84246,13.818,0.9224991,244.21706,14.117027
2022-09-01T00:00Z,246.47839,32.68204,13.812,0.9047618,243.43509,14.367475
2022-09-02T00:00Z,246.09876,32.52036,13.805,0.8871339,242.65574,14.592998
2022-09-03T00:00Z,245.72982,32.3576,13.799,0.8696305,241.87879,14.792738
2022-09-04T00:00Z,245.37145,32.19395,13.792,0.8522653,241.10388,14.965811
2022-09-05T00:00Z,245.0235,32.02959,13.786,0.8350507,240.33058,15.111304
2022-09-06T00:00Z,244.68583,31.86469,13.779,0.8179969,239.55833,15.228254
2022-09-07T00:00Z,244.35827,31.6994,13.772,0.8011122,238.78647,15.315625
2022-09-08T00:00Z,244.04067,31.53388,13.765,0.7844019,238.01421,15.37227
2022-09-09T00:00Z,243.73287,31.36827,13.758,0.7678692,237.24076,15.396888
2022-09-10T00:00Z,243.43471,31.20271,13.751,0.7515146,236.46532,15.387978
2022-09-11T00:00Z,243.14605,31.03733,13.744,0.7353376,235.68719,15.343813
2022-09-12T00:00Z,242.86671,30.87225,13.736,0.7193369,234.90579,15.262423
2022-09-13T00:00Z,242.59655,30.70759,13.729,0.7035112,234.12069,15.141599
2022-09-14T00:00Z,242.33542,30.54347,13.721,0.6878602,233.3316,14.978905
2022-09-15T00:00Z,242.08315,30.38,13.713,0.6723842,232.53828,14.771691
2022-09-16T00:00Z,241.8396,30.2173,13.705,0.6570844,231.74059,14.517087
2022-09-17T00:00Z,241.6046,30.05546,13.697,0.6419623,230.93838,14.211996
2022-09-18T00:00Z,241.37801,29.89459,13.689,0.6270194,230.13152,13.853076
2022-09-19T00:00Z,241.15965,29.7348,13.68,0.6122574,229.31987,13.436712
2022-09-20T00:00Z,240.94937,29.57618,13.672,0.5976777,228.5033,12.958994
2022-09-21T00:00Z,240.74702,29.41882,13.663,0.5832815,227.68168,12.415682
2022-09-22T00:00Z,240.55243,29.26281,13.654,0.5690696,226.85494,11.802195
2022-09-23T00:00Z,240.36543,29.10825,13.644,0.5550429,226.02303,11.113588
2022-09-24T00:00Z,240.18588,28.95522,13.635,0.5412022,225.18594,10.344555
2022-09-25T00:00Z,240.01361,28.80379,13.625,0.5275486,224.34374,9.4894424
2022-09-26T00:00Z,239.84844,28.65406,13.615,0.5140833,223.49651,8.5422757
2022-09-27T00:00Z,239.69023,28.5061,13.605,0.5008079,222.64435,7.4968135
2022-09-28T00:00Z,239.53881,28.35997,13.595,0.4877242,221.7873,6.3466139
2022-09-29T00:00Z,239.394,28.21575,13.584,0.4748342,220.92535,5.0851194
2022-09-30T00:00Z,239.25566,28.07351,13.573,0.4621397,220.05832,3.7057617
2022-10-01T00:00Z,239.1236,27.93331,13.562,0.4496421,219.18587,2.2020886
2022-10-02T00:00Z,238.99768,27.7952,13.551,0.437342,218.30743,0.5679229
2022-10-03T00:00Z,238.87772,27.65925,13.539,0.4252394,217.42222,-1.202438
2022-10-04T00:00Z,238.76358,27.52549,13.527,0.4133329,216.52921,-3.113977
2022-10-05T00:00Z,238.65509,27.39397,13.515,0.40162,215.62717,-5.170653
2022-10-06T00:00Z,238.55211,27.26474,13.503,0.3900972,214.71464,-7.375053
2022-10-07T00:00Z,238.45449,27.13783,13.49,0.3787593,213.79005,-9.727984
2022-10-08T00:00Z,238.3621,27.01328,13.477,0.3676005,212.85172,-12.22802
2022-10-09T00:00Z,238.2748,26.89113,13.464,0.3566136,211.89803,-14.87099
2022-10-10T00:00Z,238.19246,26.7714,13.45,0.3457915,210.92739,-17.64956
2022-10-11T00:00Z,238.11495,26.65413,13.437,0.3351268,209.93837,-20.55271
2022-10-12T00:00Z,238.04216,26.53936,13.422,0.3246123,208.92964,-23.56559
2022-10-13T00:00Z,237.97396,26.42712,13.408,0.3142415,207.89995,-26.66946
2022-10-14T00:00Z,237.91024,26.31744,13.393,0.3040085,206.84806,-29.84209
2022-10-15T00:00Z,237.85088,26.21037,13.378,0.2939079,205.77267,-33.05838
2022-10-16T00:00Z,237.79576,26.10593,13.363,0.2839347,204.67235,-36.29146
2022-10-17T00:00Z,237.74477,26.00416,13.347,0.2740841,203.54547,-39.51381
2022-10-18T00:00Z,237.69779,25.90511,13.331,0.2643516,202.39019,-42.69863
2022-10-19T00:00Z,237.65472,25.8088,13.315,0.2547326,201.20443,-45.82098
2022-10-20T00:00Z,237.61544,25.71528,13.299,0.2452225,199.98583,-48.85877
2022-10-21T00:00Z,237.57984,25.62459,13.282,0.2358169,198.73175,-51.79345
2022-10-22T00:00Z,237.5478,25.53675,13.264,0.2265114,197.43926,-54.61036
2022-10-23T00:00Z,237.51921,25.45183,13.247,0.217302,196.10508,-57.29872
2022-10-24T00:00Z,237.49397,25.36984,13.229,0.2081852,194.72549,-59.85145
2022-10-25T00:00Z,237.47195,25.29085,13.211,0.1991584,193.29615,-62.26471
2022-10-26T00:00Z,237.45305,25.21487,13.192,0.1902201,191.81187,-64.53746
2022-10-27T00:00Z,237.43714,25.14196,13.173,0.18137,190.26617,-66.6709
2022-10-28T00:00Z,237.42412,25.07216,13.154,0.1726092,188.65087,-68.66804
2022-10-29T00:00Z,237.41386,25.0055,13.134,0.1639401,186.95548,-70.53321
2022-10-30T00:00Z,237.40626,24.94201,13.114,0.1553664,185.16661,-72.27171
2022-10-31T00:00Z,237.4012,24.88174,13.093,0.1468929,183.26732,-73.88945
2022-11-01T00:00Z,237.39857,24.82471,13.072,0.1385259,181.23633,-75.39267
2022-11-02T00:00Z,237.39828,24.77095,13.051,0.1302737,179.04706,-76.78761
2022-11-03T00:00Z,237.40021,24.72051,13.03,0.1221472,176.66635,-78.08033
2022-11-04T00:00Z,237.40428,24.6734,13.008,0.1141616,174.05278,-79.27644
2022-11-05T00:00Z,237.41039,24.62966,12.985,0.1063373,171.15453,-80.38094
2022-11-06T00:00Z,237.41845,24.58932,12.962,0.0987031,167.90659,-81.39802
2022-11-07T00:00Z,237.42838,24.55242,12.939,0.0912992,164.22754,-82.33085
2022-11-08T00:00Z,237.44009,24.519,12.916,0.0841817,160.0161,-83.18132
2022-11-09T00:00Z,237.45351,24.48909,12.892,0.0774287,155.14869,-83.94973
2022-11-10T00:00Z,237.46855,24.46275,12.867,0.0711485,149.48054,-84.63449
2022-11-11T00:00Z,237.48513,24.44001,12.842,0.065488,142.85618,-85.23178
2022-11-12T00:00Z,237.50318,24.42094,12.817,0.0606393,135.13871,-85.73549
2022-11-13T00:00Z,237.52261,24.40557,12.791,0.0568376,126.26833,-86.13777
2022-11-14T00:00Z,237.54335,24.39398,12.765,0.0543398,116.34749,-86.43083
2022-11-15T00:00Z,237.56532,24.38622,12.738,0.0533752,105.71158,-86.61009
2022-11-16T00:00Z,237.58843,24.38235,12.711,0.0540799,94.905947,-86.67777
2022-11-17T00:00Z,237.61261,24.38245,12.684,0.0564522,84.532051,-86.64447
2022-11-18T00:00Z,237.63778,24.38659,12.656,0.0603613,75.052654,-86.52737
2022-11-19T00:00Z,237.66384,24.39484,12.628,0.0656019,66.693676,-86.34606
2022-11-20T00:00Z,237.69072,24.40728,12.599,0.0719548,59.47323,-86.11876
2022-11-21T00:00Z,237.71833,24.42401,12.569,0.0792253,53.287317,-85.86043
2022-11-22T00:00Z,237.74659,24.4451,12.54,0.0872578,47.985546,-85.58243
2022-11-23T00:00Z,237.77539,24.47066,12.509,0.0959347,43.415933,-85.29297
2022-11-24T00:00Z,237.80464,24.50078,12.478,0.1051706,39.444604,-84.99787
2022-11-25T00:00Z,237.83425,24.53556,12.447,0.1149049,35.961233,-84.70114
2022-11-26T00:00Z,237.86412,24.57511,12.415,0.1250962,32.877909,-84.40551
2022-11-27T00:00Z,237.89415,24.61954,12.383,0.135718,30.125592,-84.11279
2022-11-28T00:00Z,237.92425,24.66895,12.35,0.1467554,27.65014,-83.82409
2022-11-29T00:00Z,237.95432,24.72347,12.317,0.1582032,25.408749,-83.54007
2022-11-30T00:00Z,237.98428,24.78321,12.283,0.1700639,23.367141,-83.26101
2022-12-01T00:00Z,238.01402,24.84831,12.248,0.1823466,21.497462,-82.98695
2022-12-02T00:00Z,238.04348,24.91889,12.213,0.1950658,19.776791,-82.71774
2022-12-03T00:00Z,238.07256,24.99511,12.178,0.2082411,18.186065,-82.45312
2022-12-04T00:00Z,238.10119,25.07713,12.141,0.2218962,16.709289,-82.19273
2022-12-05T00:00Z,238.12928,25.16511,12.105,0.2360594,15.332942,-81.93612
2022-12-06T00:00Z,238.15676,25.25923,12.067,0.2507627,14.045506,-81.68282
2022-12-07T00:00Z,238.18355,25.35971,12.029,0.2660423,12.837107,-81.43232
2022-12-08T00:00Z,238.20956,25.46675,11.991,0.2819386,11.699231,-81.18406
2022-12-09T00:00Z,238.2347,25.58058,11.951,0.2984962,10.624502,-80.93747
2022-12-10T00:00Z,238.25889,25.70147,11.911,0.3157642,9.6065206,-80.69198
2022-12-11T00:00Z,238.28204,25.82969,11.871,0.3337966,8.6397194,-80.44699
2022-12-12T00:00Z,238.30405,25.96553,11.83,0.3526524,7.7192543,-80.20187
2022-12-13T00:00Z,238.32482,26.10932,11.788,0.3723967,6.8408984,-79.956
2022-12-14T00:00Z,238.34424,26.26141,11.745,0.3931009,6.0009452,-79.70873
2022-12-15T00:00Z,238.36219,26.42218,11.701,0.4148437,5.1961164,-79.45937
2022-12-16T00:00Z,238.37855,26.59204,11.657,0.4377121,4.4234761,-79.20722
2022-12-17T00:00Z,238.39318,26.77145,11.612,0.4618018,3.6803539,-78.95155
2022-12-18T00:00Z,238.40594,26.96089,11.566,0.4872186,2.9642848,-78.69158
2022-12-19T00:00Z,238.41668,27.1609,11.52,0.5140791,2.2729732,-78.42652
2022-12-20T00:00Z,238.42521,27.37205,11.472,0.5425113,1.6042926,-78.15554
2022-12-21T00:00Z,238.43134,27.59499,11.424,0.5726555,0.9563304,-77.8778
2022-12-22T00:00Z,238.43488,27.8304,11.374,0.6046655,0.3274749,-77.59245
2022-12-23T00:00Z,238.43557,28.07904,11.324,0.6387097,359.71652,-77.29859
2022-12-24T00:00Z,238.43318,28.34173,11.273,0.6749744,359.12272,-76.99534
2022-12-25T00:00Z,238.42741,28.61937,11.22,0.7136674,358.54579,-76.6817
2022-12-26T00:00Z,238.41798,28.91294,11.167,0.7550238,357.98574,-76.3566
2022-12-27T00:00Z,238.40455,29.22353,11.112,0.7993112,357.44269,-76.01881
2022-12-28T00:00Z,238.38676,29.55233,11.056,0.8468359,356.91667,-75.66694
2022-12-29T00:00Z,238.36422,29.90066,10.999,0.8979483,356.40748,-75.2994
2022-12-30T00:00Z,238.33649,30.27,10.941,0.9530491,355.91465,-74.91444
2022-12-31T00:00Z,238.30309,30.66198,10.881,1.0125954,355.43745,-74.51008
2023-01-01T00:00Z,238.26346,31.07842,10.82,1.0771096,354.97495,-74.08415
2023-01-02T00:00Z,238.21696,31.52137,10.757,1.1471893,354.52604,-73.63425
2023-01-03T00:00Z,238.16288,31.99313,10.692,1.2235194,354.08948,-73.15772
2023-01-04T00:00Z,238.10038,32.49628,10.626,1.3068872,353.6639,-72.65161
2023-01-05T00:00Z,238.02849,33.03371,10.558,1.3982,353.24782,-72.11263
2023-01-06T00:00Z,237.94608,33.60872,10.488,1.4985069,352.83962,-71.53712
2023-01-07T00:00Z,237.85182,34.22502,10.416,1.6090243,352.43752,-70.92095
2023-01-08T00:00Z,237.74414,34.88684,10.342,1.7311665,352.03959,-70.2595
2023-01-09T00:00Z,237.62115,35.59898,10.266,1.8665833,351.64366,-69.54752
2023-01-10T00:00Z,237.48061,36.36695,10.187,2.017204,351.24727,-68.77907
2023-01-11T00:00Z,237.3198,37.19703,10.106,2.1852917,350.84762,-67.94739
2023-01-12T00:00Z,237.13538,38.09644,10.022,2.3735073,350.44146,-67.04473
2023-01-13T00:00Z,236.92326,39.0735,9.935,2.5849857,350.02486,-66.06221
2023-01-14T00:00Z,236.67834,40.1378,9.846,2.8234256,349.59309,-64.98959
2023-01-15T00:00Z,236.39419,41.30041,9.753,3.0931932,349.14022,-63.81504
2023-01-16T00:00Z,236.06261,42.57418,9.657,3.3994381,348.65877,-62.52484
2023-01-17T00:00Z,235.67295,43.97395,9.557,3.7482169,348.13901,-61.10306
2023-01-18T00:00Z,235.21119,45.51693,9.454,4.1466148,347.56806,-59.53119
2023-01-19T00:00Z,234.65847,47.22292,9.348,4.6028419,346.92852,-57.7877
2023-01-20T00:00Z,233.98884,49.11466,9.238,5.1262665,346.19624,-55.8476
2023-01-21T00:00Z,233.1657,51.21788,9.125,5.7273157,345.33671,-53.68198
2023-01-22T00:00Z,232.13569,53.56121,9.009,6.4171228,344.29908,-51.25765
2023-01-23T00:00Z,230.81818,56.17527,8.89,7.2067306,343.00545,-48.53693
2023-01-24T00:00Z,229.08561,59.09066,8.77,8.1055575,341.33117,-45.47798
2023-01-25T00:00Z,226.72474,62.33316,8.65,9.118734,339.06599,-42.03589
2023-01-26T00:00Z,223.354,65.9133,8.532,10.24288,335.83175,-38.16517
2023-01-27T00:00Z,218.23157,69.80231,8.418,11.460098,330.89226,-33.82433
2023-01-28T00:00Z,209.77575,73.87069,8.311,12.730651,322.68264,-28.98314
2023-01-29T00:00Z,194.43788,77.70905,8.217,13.986343,307.71972,-23.63279
2023-01-30T00:00Z,166.43855,80.15307,8.14,15.128805,280.38711,-17.79787
2023-01-31T00:00Z,131.1373,79.32236,8.085,16.038422,245.79499,-11.54714
2023-02-01T00:00Z,107.03712,75.33533,8.056,16.597451,222.04067,-4.997813
2023-02-02T00:00Z,94.12072,69.8492,8.057,16.72295,209.41121,1.6915811
2023-02-03T00:00Z,86.82766,63.85049,8.087,16.395089,202.43975,8.3412851
2023-02-04T00:00Z,82.3043,57.81292,8.145,15.664493,198.25226,14.777898
2023-02-05T00:00Z,79.27674,51.99903,8.227,14.633926,195.549,20.859641
2023-02-06T00:00Z,77.13237,46.55997,8.329,13.425696,193.6982,26.490868
2023-02-07T00:00Z,75.54842,41.57225,8.446,12.151888,192.36397,31.623594
2023-02-08T00:00Z,74.34086,37.06013,8.573,10.897684,191.35375,36.249575
2023-02-09T00:00Z,73.39785,33.01354,8.706,9.7178985,190.55051,40.388477
2023-02-10T00:00Z,72.64773,29.40235,8.842,8.6415604,189.87972,44.076477
2023-02-11T00:00Z,72.04259,26.18671,8.979,7.6792174,189.29209,47.357382
2023-02-12T00:00Z,71.54927,23.32382,9.115,6.8298008,188.75392,50.276651
2023-02-13T00:00Z,71.14407,20.77191,9.248,6.085834,188.24148,52.877849
2023-02-14T00:00Z,70.80965,18.49236,9.379,5.4369118,187.73755,55.200825
2023-02-15T00:00Z,70.53302,16.45053,9.507,4.8718112,187.22926,57.280995
2023-02-16T00:00Z,70.30428,14.61599,9.631,4.3796586,186.70679,59.149268
2023-02-17T00:00Z,70.11574,12.96229,9.751,3.9505007,186.16246,60.83231
2023-02-18T00:00Z,69.96134,11.4666,9.868,3.5755227,185.59021,62.352966
2023-02-19T00:00Z,69.83622,10.10931,9.981,3.2470726,184.98524,63.730749
2023-02-20T00:00Z,69.73648,8.87354,10.091,2.9585869,184.3438,64.98231
2023-02-21T00:00Z,69.65888,7.74479,10.197,2.7044727,183.66295,66.121889
2023-02-22T00:00Z,69.60078,6.71061,10.3,2.4799802,182.94043,67.161705
2023-02-23T00:00Z,69.55993,5.76023,10.4,2.2810805,182.17441,68.112266
2023-02-24T00:00Z,69.53446,4.88436,10.496,2.1043555,181.36341,68.982635
2023-02-25T00:00Z,69.52277,4.07493,10.59,1.9469038,180.50616,69.780628
2023-02-26T00:00Z,69.5235,3.32496,10.681,1.806259,179.6016,70.512986
2023-02-27T00:00Z,69.53549,2.62834,10.77,1.6803211,178.6489,71.18552
2023-02-28T00:00Z,69.55772,1.97972,10.856,1.5672982,177.64748,71.803242
2023-03-01T00:00Z,69.58931,1.37442,10.94,1.4656571,176.59706,72.370474
2023-03-02T00:00Z,69.62952,0.80832,11.021,1.3740822,175.49769,72.890952
2023-03-03T00:00Z,69.67767,0.27778,11.1,1.2914409,174.34977,73.367906
2023-03-04T00:00Z,69.73318,-0.22043,11.178,1.2167548,173.15406,73.804135
2023-03-05T00:00Z,69.79554,-0.68917,11.253,1.1491762,171.91175,74.20207
2023-03-06T00:00Z,69.86428,-1.131,11.327,1.0879677,170.62439,74.56382
2023-03-07T00:00Z,69.93899,-1.54819,11.399,1.0324859,169.29393,74.891222
2023-03-08T00:00Z,70.01933,-1.94279,11.469,0.9821677,167.92274,75.185872
2023-03-09T00:00Z,70.10496,-2.31663,11.537,0.9365185,166.51359,75.449155
2023-03-10T00:00Z,70.19561,-2.67138,11.604,0.8951025,165.06969,75.682277
2023-03-11T00:00Z,70.291,-3.00851,11.67,0.8575346,163.59465,75.886284
2023-03-12T00:00Z,70.3909,-3.32938,11.734,0.823473,162.09254,76.062091
2023-03-13T00:00Z,70.49512,-3.63523,11.797,0.7926131,160.56782,76.210499
2023-03-14T00:00Z,70.60345,-3.92716,11.858,0.7646826,159.02541,76.332218
2023-03-15T00:00Z,70.71572,-4.20621,11.918,0.7394364,157.47059,76.427889
2023-03-16T00:00Z,70.83178,-4.4733,11.977,0.7166529,155.90902,76.498103
2023-03-17T00:00Z,70.95148,-4.72929,12.035,0.6961305,154.34671,76.54343
2023-03-18T00:00Z,71.07468,-4.97497,12.092,0.6776839,152.78994,76.564444
2023-03-19T00:00Z,71.20125,-5.21107,12.148,0.6611413,151.24517,76.561754
2023-03-20T00:00Z,71.33108,-5.43826,12.202,0.6463423,149.71888,76.536036
2023-03-21T00:00Z,71.46403,-5.65716,12.256,0.6331356,148.21729,76.488049
2023-03-22T00:00Z,71.6,-5.86836,12.308,0.621379,146.74617,76.418634
2023-03-23T00:00Z,71.73886,-6.07239,12.36,0.6109391,145.31052,76.328695
2023-03-24T00:00Z,71.88051,-6.26974,12.411,0.6016925,143.91448,76.21916
2023-03-25T00:00Z,72.02483,-6.46087,12.46,0.5935257,142.56131,76.090947
2023-03-26T00:00Z,72.17173,-6.64621,12.509,0.5863357,141.25343,75.944932
2023-03-27T00:00Z,72.32111,-6.82615,12.557,0.5800292,139.99257,75.78194
2023-03-28T00:00Z,72.47287,-7.00106,12.605,0.574522,138.77991,75.60274
2023-03-29T00:00Z,72.62692,-7.17127,12.651,0.5697382,137.61614,75.408045
2023-03-30T00:00Z,72.78319,-7.33711,12.697,0.5656089,136.50157,75.198521
2023-03-31T00:00Z,72.94159,-7.49888,12.742,0.5620719,135.43616,74.974792
2023-04-01T00:00Z,73.10206,-7.65684,12.786,0.5590708,134.41958,74.737439
2023-04-02T00:00Z,73.26452,-7.81126,12.829,0.5565548,133.45124,74.487006
2023-04-03T00:00Z,73.42891,-7.96238,12.872,0.5544778,132.53028,74.223991
2023-04-04T00:00Z,73.59517,-8.11044,12.914,0.552799,131.65568,73.948847
2023-04-05T00:00Z,73.76325,-8.25563,12.956,0.5514816,130.82623,73.661973
2023-04-06T00:00Z,73.93308,-8.39817,12.997,0.5504933,130.04063,73.363714
2023-04-07T00:00Z,74.10462,-8.53824,13.037,0.5498057,129.29749,73.054357
2023-04-08T00:00Z,74.27782,-8.67602,13.076,0.5493934,128.59546,72.734133
2023-04-09T00:00Z,74.45265,-8.81168,13.115,0.5492345,127.93324,72.403223
2023-04-10T00:00Z,74.62905,-8.94538,13.154,0.5493087,127.30959,72.061775
2023-04-11T00:00Z,74.807,-9.07729,13.192,0.5495977,126.72343,71.709912
2023-04-12T00:00Z,74.98646,-9.20753,13.229,0.5500842,126.1738,71.347751
2023-04-13T00:00Z,75.16739,-9.33626,13.266,0.5507516,125.65985,70.975417
2023-04-14T00:00Z,75.34976,-9.46361,13.302,0.5515833,125.18085,70.593062
2023-04-15T00:00Z,75.53353,-9.58971,13.337,0.5525629,124.73615,70.200873
2023-04-16T00:00Z,75.71868,-9.7147,13.373,0.5536736,124.32512,69.799089
2023-04-17T00:00Z,75.90515,-9.83868,13.407,0.5548986,123.94712,69.388001
2023-04-18T00:00Z,76.09292,-9.96178,13.441,0.5562208,123.60145,68.967957
2023-04-19T00:00Z,76.28194,-10.08412,13.475,0.5576242,123.28727,68.539343
2023-04-20T00:00Z,76.47217,-10.2058,13.508,0.5590934,123.00358,68.10256
2023-04-21T00:00Z,76.66356,-10.32692,13.541,0.5606151,122.74922,67.658002
2023-04-22T00:00Z,76.85606,-10.44758,13.573,0.5621779,122.52291,67.206024
2023-04-23T00:00Z,77.04965,-10.56787,13.605,0.5637729,122.32328,66.746929
2023-04-24T00:00Z,77.24425,-10.68788,13.636,0.5653928,122.14896,66.280965
2023-04-25T00:00Z,77.43985,-10.8077,13.667,0.5670323,121.99862,65.808325
2023-04-26T00:00Z,77.63639,-10.92739,13.698,0.5686873,121.87096,65.329164
2023-04-27T00:00Z,77.83383,-11.04704,13.728,0.5703547,121.76481,64.843605
2023-04-28T00:00Z,78.03214,-11.16672,13.758,0.5720318,121.67904,64.351751
2023-04-29T00:00Z,78.23128,-11.28649,13.787,0.5737167,121.61259,63.853689
2023-04-30T00:00Z,78.43121,-11.40641,13.816,0.575408,121.56449,63.349495
2023-05-01T00:00Z,78.6319,-11.52656,13.844,0.5771046,121.53378,62.839232
2023-05-02T00:00Z,78.83332,-11.64698,13.872,0.5788061,121.51956,62.322943
2023-05-03T00:00Z,79.03543,-11.76773,13.9,0.5805128,121.52095,61.800646
2023-05-04T00:00Z,79.23821,-11.88887,13.927,0.5822257,121.53713,61.27232
2023-05-05T00:00Z,79.44163,-12.01045,13.954,0.5839465,121.56733,60.737905
2023-05-06T00:00Z,79.64566,-12.13251,13.981,0.5856777,121.61089,60.197297
2023-05-07T00:00Z,79.85028,-12.25512,14.007,0.5874217,121.66724,59.650356
2023-05-08T00:00Z,80.05548,-12.3783,14.033,0.5891812,121.73597,59.096921
2023-05-09T00:00Z,80.26122,-12.50212,14.059,0.5909581,121.8168,58.536839
2023-05-10T00:00Z,80.46749,-12.62662,14.084,0.5927533,121.90961,57.969987
2023-05-11T00:00Z,80.67428,-12.75185,14.109,0.5945666,122.01436,57.396302
2023-05-12T00:00Z,80.88155,-12.87785,14.134,0.5963966,122.1311,56.81579
2023-05-13T00:00Z,81.08929,-13.00467,14.158,0.5982405,122.25988,56.228538
2023-05-14T00:00Z,81.29747,-13.13236,14.182,0.6000948,122.40076,55.634713
2023-05-15T00:00Z,81.50607,-13.26097,14.206,0.6019554,122.55375,55.03455
2023-05-16T00:00Z,81.71506,-13.39054,14.229,0.6038176,122.71879,54.428348
2023-05-17T00:00Z,81.9244,-13.52112,14.252,0.6056771,122.89573,53.81645
2023-05-18T00:00Z,82.13408,-13.65275,14.275,0.6075298,123.08435,53.199225
2023-05-19T00:00Z,82.34405,-13.78548,14.297,0.6093721,123.2843,52.577052
2023-05-20T00:00Z,82.55428,-13.91933,14.32,0.6112014,123.4952,51.950296
2023-05-21T00:00Z,82.76474,-14.05436,14.341,0.613016,123.71659,51.319295
2023-05-22T00:00Z,82.97539,-14.19059,14.363,0.6148151,123.94799,50.684352
2023-05-23T00:00Z,83.1862,-14.32807,14.384,0.6165988,124.18892,50.045737
2023-05-24T00:00Z,83.39714,-14.46681,14.406,0.6183675,124.43891,49.403688
2023-05-25T00:00Z,83.60818,-14.60686,14.426,0.6201223,124.69754,48.75842
2023-05-26T00:00Z,83.81928,-14.74825,14.447,0.6218644,124.96439,48.110138
2023-05-27T00:00Z,84.03041,-14.89099,14.467,0.6235952,125.23907,47.459037
2023-05-28T00:00Z,84.24155,-15.03512,14.487,0.6253161,125.52124,46.805314
2023-05-29T00:00Z,84.45266,-15.18067,14.507,0.6270288,125.81052,46.149161
2023-05-30T00:00Z,84.66372,-15.32766,14.526,0.6287352,126.10659,45.490763
2023-05-31T00:00Z,84.8747,-15.47611,14.546,0.6304375,126.40908,44.830289
2023-06-01T00:00Z,85.08558,-15.62604,14.565,0.6321384,126.71765,44.167881
2023-06-02T00:00Z,85.29633,-15.77748,14.583,0.6338412,127.03199,43.503635
2023-06-03T00:00Z,85.50694,-15.93046,14.602,0.6355498,127.35181,42.837593
2023-06-04T00:00Z,85.71737,-16.08499,14.62,0.6372683,127.67691,42.169746
2023-06-05T00:00Z,85.92761,-16.24109,14.638,0.6390009,128.0072,41.500041
2023-06-06T00:00Z,86.13764,-16.3988,14.656,0.6407513,128.34271,40.828423
2023-06-07T00:00Z,86.34745,-16.55812,14.674,0.6425221,128.68361,40.154874
2023-06-08T00:00Z,86.55701,-16.7191,14.691,0.6443145,129.03016,39.479453
2023-06-09T00:00Z,86.7663,-16.88175,14.709,0.6461281,129.38264,38.802325
2023-06-10T00:00Z,86.97531,-17.04611,14.725,0.6479617,129.74135,38.123767
2023-06-11T00:00Z,87.18401,-17.21219,14.742,0.6498127,130.10655,37.444152
2023-06-12T00:00Z,87.39236,-17.38003,14.759,0.6516786,130.4784,36.763931
2023-06-13T00:00Z,87.60035,-17.54966,14.775,0.6535562,130.85702,36.083607
2023-06-14T00:00Z,87.80794,-17.7211,14.791,0.655443,131.24241,35.403713
2023-06-15T00:00Z,88.0151,-17.89438,14.807,0.6573363,131.63453,34.724797
2023-06-16T00:00Z,88.2218,-18.06952,14.823,0.6592342,132.03326,34.047404
2023-06-17T00:00Z,88.428,-18.24654,14.838,0.661135,132.43843,33.372068
2023-06-18T00:00Z,88.63367,-18.42547,14.854,0.6630377,132.84984,32.699298
2023-06-19T00:00Z,88.83878,-18.60632,14.869,0.6649418,133.26724,32.029577
2023-06-20T00:00Z,89.04328,-18.78912,14.884,0.6668473,133.69038,31.363351
2023-06-21T00:00Z,89.24715,-18.97388,14.899,0.6687546,134.119,30.701036
2023-06-22T00:00Z,89.45034,-19.16062,14.913,0.6706643,134.55286,30.043016
2023-06-23T00:00Z,89.65284,-19.34935,14.928,0.6725774,134.99171,29.38965
2023-06-24T00:00Z,89.8546,-19.54009,14.942,0.674495,135.43531,28.741277
2023-06-25T00:00Z,90.05558,-19.73285,14.956,0.6764184,135.88344,28.09822
2023-06-26T00:00Z,90.25577,-19.92765,14.97,0.6783488,136.33588,27.460787
2023-06-27T00:00Z,90.45512,-20.12449,14.984,0.6802877,136.79239,26.829269
2023-06-28T00:00Z,90.6536,-20.3234,14.997,0.682237,137.25275,26.203937
2023-06-29T00:00Z,90.85119,-20.52437,15.011,0.6841987,137.71669,25.585024
2023-06-30T00:00Z,91.04786,-20.72743,15.024,0.6861756,138.18399,24.972719
2023-07-01T00:00Z,91.24357,-20.93258,15.037,0.6881708,138.65442,24.367143
2023-07-02T00:00Z,91.43831,-21.13983,15.05,0.6901884,139.1278,23.768346
2023-07-03T00:00Z,91.63204,-21.34919,15.062,0.6922326,139.60405,23.176306
2023-07-04T00:00Z,91.82473,-21.56068,15.075,0.6943073,140.08322,22.590962
2023-07-05T00:00Z,92.01638,-21.77431,15.088,0.6964161,140.56549,22.012253
2023-07-06T00:00Z,92.20694,-21.99009,15.1,0.6985606,141.05113,21.440178
2023-07-07T00:00Z,92.39639,-22.20804,15.112,0.7007415,141.54052,20.874833
2023-07-08T00:00Z,92.5847,-22.42818,15.124,0.7029575,142.03398,20.316422
2023-07-09T00:00Z,92.77183,-22.65053,15.136,0.7052064,142.5318,19.765251
2023-07-10T00:00Z,92.95776,-22.87509,15.148,0.7074857,143.0342,19.221687
2023-07-11T00:00Z,93.14244,-23.10188,15.159,0.7097925,143.54129,18.686134
2023-07-12T00:00Z,93.32583,-23.33093,15.171,0.7121241,144.05311,18.158998
2023-07-13T00:00Z,93.50788,-23.56224,15.182,0.7144782,144.56962,17.640675
2023-07-14T00:00Z,93.68857,-23.79582,15.193,0.7168526,145.09077,17.131539
2023-07-15T00:00Z,93.86784,-24.03169,15.204,0.7192456,145.61642,16.631936
2023-07-16T00:00Z,94.04564,-24.26985,15.215,0.7216558,146.14644,16.142183
2023-07-17T00:00Z,94.22193,-24.51031,15.226,0.7240822,146.68066,15.662566
2023-07-18T00:00Z,94.39667,-24.75308,15.236,0.7265237,147.21891,15.19334
2023-07-19T00:00Z,94.5698,-24.99815,15.247,0.7289798,147.761,14.734729
2023-07-20T00:00Z,94.74128,-25.24554,15.257,0.7314502,148.30674,14.286926
2023-07-21T00:00Z,94.91107,-25.49525,15.268,0.7339347,148.85592,13.850093
2023-07-22T00:00Z,95.07911,-25.74728,15.278,0.7364333,149.40837,13.424369
2023-07-23T00:00Z,95.24536,-26.00162,15.288,0.7389462,149.96388,13.009868
2023-07-24T00:00Z,95.40977,-26.25827,15.298,0.7414734,150.52226,12.606681
2023-07-25T00:00Z,95.5723,-26.51724,15.308,0.7440156,151.08333,12.21488
2023-07-26T00:00Z,95.7329,-26.77852,15.318,0.7465731,151.64687,11.834516
2023-07-27T00:00Z,95.89151,-27.0421,15.327,0.7491469,152.21268,11.465609
2023-07-28T00:00Z,96.0481,-27.30799,15.337,0.7517382,152.78054,11.108145
2023-07-29T00:00Z,96.20263,-27.57617,15.346,0.7543491,153.35024,10.762063
2023-07-30T00:00Z,96.35504,-27.84664,15.356,0.7569821,153.9216,10.427243
2023-07-31T00:00Z,96.50529,-28.11939,15.365,0.7596405,154.49452,10.103507
2023-08-01T00:00Z,96.65334,-28.39443,15.374,0.7623279,155.06898,9.7906316
2023-08-02T00:00Z,96.79915,-28.67174,15.383,0.7650475,155.64512,9.488376
2023-08-03T00:00Z,96.94266,-28.95132,15.392,0.7678017,156.22321,9.1965296
2023-08-04T00:00Z,97.08383,-29.23318,15.401,0.7705912,156.80359,8.9149528
2023-08-05T00:00Z,97.22261,-29.51731,15.41,0.7734149,157.38663,8.6435989
2023-08-06T00:00Z,97.35894,-29.8037,15.419,0.7762703,157.97266,8.3825092
2023-08-07T00:00Z,97.49276,-30.09236,15.427,0.7791542,158.56194,8.1317882
2023-08-08T00:00Z,97.62401,-30.38328,15.436,0.7820626,159.15461,7.891571
2023-08-09T00:00Z,97.75262,-30.67645,15.445,0.7849918,159.75075,7.6619974
2023-08-10T00:00Z,97.87853,-30.97187,15.453,0.7879382,160.35037,7.4431944
2023-08-11T00:00Z,98.00167,-31.26951,15.461,0.7908986,160.95345,7.2352686
2023-08-12T00:00Z,98.12196,-31.56937,15.47,0.7938699,161.55991,7.0383039
2023-08-13T00:00Z,98.23933,-31.87144,15.478,0.7968493,162.16968,6.852363
2023-08-14T00:00Z,98.35372,-32.17569,15.486,0.7998342,162.78268,6.6774892
2023-08-15T00:00Z,98.46503,-32.4821,15.494,0.8028221,163.39882,6.513708
2023-08-16T00:00Z,98.5732,-32.79066,15.503,0.8058105,164.01798,6.3610282
2023-08-17T00:00Z,98.67816,-33.10133,15.511,0.8087971,164.64006,6.2194423
2023-08-18T00:00Z,98.77981,-33.41409,15.519,0.8117799,165.26493,6.0889267
2023-08-19T00:00Z,98.87809,-33.72892,15.526,0.8147568,165.89249,5.9694417
2023-08-20T00:00Z,98.97291,-34.04578,15.534,0.8177259,166.5226,5.8609319
2023-08-21T00:00Z,99.06419,-34.36464,15.542,0.8206855,167.15515,5.7633271
2023-08-22T00:00Z,99.15186,-34.68547,15.55,0.8236342,167.79002,5.6765421
2023-08-23T00:00Z,99.23582,-35.00823,15.558,0.8265705,168.42706,5.6004764
2023-08-24T00:00Z,99.316,-35.33289,15.565,0.8294934,169.06616,5.5350122
2023-08-25T00:00Z,99.39232,-35.6594,15.573,0.8324022,169.70718,5.4800106
2023-08-26T00:00Z,99.4647,-35.98774,15.581,0.8352969,170.34998,5.4353064
2023-08-27T00:00Z,99.53304,-36.31785,15.588,0.8381781,170.99447,5.4007027
2023-08-28T00:00Z,99.59727,-36.64969,15.596,0.8410471,171.64057,5.3759684
2023-08-29T00:00Z,99.6573,-36.98323,15.604,0.843906,172.28832,5.3608438
2023-08-30T00:00Z,99.71305,-37.31843,15.611,0.846757,172.93783,5.3550565
2023-08-31T00:00Z,99.76443,-37.65523,15.619,0.849602,173.58938,5.358349
2023-09-01T00:00Z,99.81134,-37.99361,15.626,0.8524416,174.24332,5.3705077
2023-09-02T00:00Z,99.85369,-38.33352,15.634,0.8552745,174.90009,5.3913846
2023-09-03T00:00Z,99.89138,-38.67492,15.641,0.8580979,175.56011,5.4208993
2023-09-04T00:00Z,99.92429,-39.01776,15.648,0.8609075,176.22373,5.4590247
2023-09-05T00:00Z,99.95233,-39.36199,15.656,0.8636982,176.89124,5.5057635
2023-09-06T00:00Z,99.97536,-39.70756,15.663,0.8664646,177.56283,5.5611259
2023-09-07T00:00Z,99.99328,-40.05442,15.671,0.8692015,178.23864,5.6251151
2023-09-08T00:00Z,100.00595,-40.4025,15.678,0.8719038,178.91876,5.6977189
2023-09-09T00:00Z,100.01327,-40.75174,15.686,0.8745668,179.60327,5.7789092
2023-09-10T00:00Z,100.01509,-41.10209,15.693,0.8771861,180.29222,5.8686427
2023-09-11T00:00Z,100.0113,-41.45346,15.7,0.8797574,180.98567,5.9668636
2023-09-12T00:00Z,100.00175,-41.80579,15.708,0.8822765,181.68367,6.0735065
2023-09-13T00:00Z,99.98633,-42.159,15.715,0.8847394,182.38627,6.1884972
2023-09-14T00:00Z,99.96489,-42.51302,15.723,0.8871419,183.0935,6.3117539
2023-09-15T00:00Z,99.9373,-42.86776,15.73,0.8894804,183.80541,6.4431866
2023-09-16T00:00Z,99.90343,-43.22314,15.738,0.891751,184.52203,6.5826963
2023-09-17T00:00Z,99.86312,-43.57907,15.745,0.8939501,185.24337,6.7301736
2023-09-18T00:00Z,99.81626,-43.93547,15.753,0.8960746,185.96945,6.8854982
2023-09-19T00:00Z,99.76269,-44.29223,15.76,0.8981215,186.70027,7.0485373
2023-09-20T00:00Z,99.70227,-44.64927,15.768,0.9000883,187.43583,7.2191455
2023-09-21T00:00Z,99.63486,-45.0065,15.775,0.9019727,188.17615,7.3971636
2023-09-22T00:00Z,99.56033,-45.3638,15.783,0.9037733,188.92123,7.5824178
2023-09-23T00:00Z,99.47853,-45.72108,15.79,0.905489,189.67107,7.7747174
2023-09-24T00:00Z,99.38932,-46.07824,15.798,0.9071197,190.4257,7.9738544
2023-09-25T00:00Z,99.29255,-46.43518,15.806,0.908666,191.18518,8.1796025
2023-09-26T00:00Z,99.18808,-46.79178,15.813,0.9101291,191.94964,8.3917212
2023-09-27T00:00Z,99.07577,-47.14795,15.821,0.911511,192.71927,8.6099645
2023-09-28T00:00Z,98.95547,-47.50358,15.829,0.9128136,193.49439,8.8340954
2023-09-29T00:00Z,98.82702,-47.85856,15.837,0.9140381,194.2754,9.063904
2023-09-30T00:00Z,98.69027,-48.21278,15.845,0.9151846,195.0628,9.2992221
2023-10-01T00:00Z,98.54506,-48.56614,15.853,0.9162513,195.85709,9.539928
2023-10-02T00:00Z,98.39122,-48.91852,15.86,0.9172351,196.65876,9.7859406
2023-10-03T00:00Z,98.2286,-49.2698,15.868,0.9181316,197.46825,10.037205
2023-10-04T00:00Z,98.05701,-49.61986,15.877,0.9189361,198.28591,10.293675
2023-10-05T00:00Z,97.87629,-49.96857,15.885,0.9196435,199.11204,10.555304
2023-10-06T00:00Z,97.68628,-50.31581,15.893,0.9202494,199.94688,10.822033
2023-10-07T00:00Z,97.48679,-50.66143,15.901,0.9207494,200.79065,11.093792
2023-10-08T00:00Z,97.27766,-51.00531,15.909,0.9211396,201.64355,11.370499
2023-10-09T00:00Z,97.05874,-51.3473,15.917,0.9214164,202.50576,11.652065
2023-10-10T00:00Z,96.82984,-51.68725,15.926,0.9215766,203.37747,11.938391
2023-10-11T00:00Z,96.59083,-52.02503,15.934,0.921617,204.25884,12.229378
2023-10-12T00:00Z,96.34153,-52.36049,15.943,0.9215346,205.15005,12.524918
2023-10-13T00:00Z,96.08181,-52.69346,15.951,0.9213265,206.05123,12.824905
2023-10-14T00:00Z,95.81151,-53.0238,15.96,0.92099,206.96252,13.129224
2023-10-15T00:00Z,95.53049,-53.35134,15.968,0.9205229,207.88403,13.437757
2023-10-16T00:00Z,95.23863,-53.67594,15.977,0.9199229,208.81583,13.750375
2023-10-17T00:00Z,94.9358,-53.99743,15.986,0.9191885,209.75798,14.06694
2023-10-18T00:00Z,94.62189,-54.31565,15.994,0.9183189,210.71051,14.387302
2023-10-19T00:00Z,94.2968,-54.63043,16.003,0.9173139,211.67344,14.711298
2023-10-20T00:00Z,93.96043,-54.94162,16.012,0.9161738,212.64676,15.038752
2023-10-21T00:00Z,93.6127,-55.24905,16.021,0.9149002,213.63047,15.369475
2023-10-22T00:00Z,93.25353,-55.55256,16.03,0.913495,214.62458,15.703268
2023-10-23T00:00Z,92.88287,-55.85199,16.039,0.9119613,215.62913,16.039922
2023-10-24T00:00Z,92.50067,-56.14719,16.049,0.9103025,216.64417,16.379223
2023-10-25T00:00Z,92.1069,-56.43798,16.058,0.9085227,217.66983,16.720957
2023-10-26T00:00Z,91.70153,-56.72423,16.067,0.9066262,218.70628,17.064916
2023-10-27T00:00Z,91.28454,-57.00576,16.076,0.9046169,219.75377,17.410912
2023-10-28T00:00Z,90.85594,-57.28244,16.086,0.9024979,220.81263,17.75878
2023-10-29T00:00Z,90.41574,-57.55409,16.095,0.9002711,221.88317,18.108388
2023-10-30T00:00Z,89.96397,-57.82058,16.105,0.8979374,222.96571,18.459634
2023-10-31T00:00Z,89.50067,-58.08174,16.115,0.8954963,224.06054,18.812439
2023-11-01T00:00Z,89.02589,-58.33742,16.124,0.8929466,225.16786,19.166737
2023-11-02T00:00Z,88.53974,-58.58747,16.134,0.8902869,226.28779,19.522465
2023-11-03T00:00Z,88.0423,-58.83173,16.144,0.8875159,227.42039,19.879559
2023-11-04T00:00Z,87.5337,-59.07006,16.154,0.8846324,228.56565,20.237944
2023-11-05T00:00Z,87.01411,-59.3023,16.164,0.8816357,229.72352,20.597541
2023-11-06T00:00Z,86.48368,-59.5283,16.174,0.8785255,230.89391,20.958264
2023-11-07T00:00Z,85.94264,-59.74793,16.184,0.8753016,232.0767,21.320023
2023-11-08T00:00Z,85.39121,-59.96105,16.194,0.8719641,233.27174,21.682723
2023-11-09T00:00Z,84.82964,-60.16751,16.204,0.8685132,234.47883,22.046273
2023-11-10T00:00Z,84.25823,-60.36719,16.214,0.8649493,235.69776,22.410578
2023-11-11T00:00Z,83.67728,-60.55996,16.225,0.8612726,236.92826,22.775547
2023-11-12T00:00Z,83.08715,-60.74571,16.235,0.8574836,238.17,23.141085
2023-11-13T00:00Z,82.4882,-60.92432,16.245,0.8535832,239.4226,23.507093
2023-11-14T00:00Z,81.88083,-61.09569,16.256,0.8495723,240.68563,23.873466
2023-11-15T00:00Z,81.26548,-61.25973,16.266,0.8454527,241.95856,24.240087
2023-11-16T00:00Z,80.64259,-61.41633,16.277,0.8412269,243.24085,24.606829
2023-11-17T00:00Z,80.01266,-61.56543,16.288,0.8368983,244.53191,24.973548
2023-11-18T00:00Z,79.37617,-61.70696,16.298,0.8324712,245.83112,25.340087
2023-11-19T00:00Z,78.73367,-61.84085,16.309,0.8279505,247.13789,25.70628
2023-11-20T00:00Z,78.08568,-61.96707,16.32,0.8233418,248.45165,26.071954
2023-11-21T00:00Z,77.43278,-62.08557,16.331,0.8186514,249.77184,26.436935
2023-11-22T00:00Z,76.77554,-62.19632,16.341,0.8138853,251.09799,26.801048
2023-11-23T00:00Z,76.11454,-62.29932,16.352,0.8090497,252.42966,27.164127
2023-11-24T00:00Z,75.45038,-62.39454,16.363,0.8041506,253.76647,27.526017
2023-11-25T00:00Z,74.78367,-62.48199,16.374,0.7991932,255.10809,27.886579
2023-11-26T00:00Z,74.11501,-62.56169,16.385,0.7941819,256.4542,28.245693
2023-11-27T00:00Z,73.44502,-62.63364,16.397,0.7891203,257.80453,28.603259
2023-11-28T00:00Z,72.77431,-62.69788,16.408,0.7840109,259.15876,28.959196
2023-11-29T00:00Z,72.1035,-62.75444,16.419,0.7788557,260.51658,29.313439
2023-11-30T00:00Z,71.43323,-62.80336,16.43,0.773656,261.87762,29.66593
2023-12-01T00:00Z,70.76409,-62.8447,16.441,0.7684128,263.24147,30.016617
2023-12-02T00:00Z,70.09673,-62.8785,16.453,0.7631273,264.60769,30.365447
2023-12-03T00:00Z,69.43173,-62.90485,16.464,0.7578007,265.97582,30.712365
2023-12-04T00:00Z,68.76972,-62.9238,16.475,0.7524341,267.34539,31.057311
2023-12-05T00:00Z,68.11129,-62.93546,16.487,0.7470291,268.71591,31.400224
2023-12-06T00:00Z,67.45701,-62.93991,16.498,0.7415874,270.0869,31.741041
2023-12-07T00:00Z,66.80748,-62.93724,16.51,0.7361103,271.45791,32.079701
2023-12-08T00:00Z,66.16323,-62.92757,16.521,0.7305995,272.82848,32.416143
2023-12-09T00:00Z,65.52481,-62.91102,16.533,0.7250563,274.19813,32.750312
2023-12-10T00:00Z,64.89274,-62.8877,16.544,0.7194821,275.56641,33.082156
2023-12-11T00:00Z,64.26753,-62.85774,16.556,0.713878,276.93283,33.411626
2023-12-12T00:00Z,63.64964,-62.82127,16.567,0.7082452,278.29687,33.738671
2023-12-13T00:00Z,63.03955,-62.77845,16.579,0.7025856,279.65797,34.063239
2023-12-14T00:00Z,62.43768,-62.72941,16.59,0.6969011,281.01555,34.385263
2023-12-15T00:00Z,61.84444,-62.67431,16.602,0.6911949,282.36901,34.704663
2023-12-16T00:00Z,61.26021,-62.61331,16.614,0.6854708,283.71779,35.021339
2023-12-17T00:00Z,60.68534,-62.54657,16.625,0.6797336,285.06138,35.335174
2023-12-18T00:00Z,60.12015,-62.47426,16.637,0.6739887,286.39935,35.646037
2023-12-19T00:00Z,59.56493,-62.39654,16.649,0.6682418,287.73137,35.953789
2023-12-20T00:00Z,59.01995,-62.3136,16.66,0.6624985,289.05724,36.25829
2023-12-21T00:00Z,58.48543,-62.2256,16.672,0.6567643,290.37684,36.559403
2023-12-22T00:00Z,57.96157,-62.13271,16.684,0.651044,291.69012,36.856999
2023-12-23T00:00Z,57.44857,-62.03511,16.695,0.6453421,292.99713,37.150958
2023-12-24T00:00Z,56.94655,-61.93297,16.707,0.6396625,294.29794,37.441171
2023-12-25T00:00Z,56.45566,-61.82645,16.719,0.6340082,295.59271,37.727542
2023-12-26T00:00Z,55.97601,-61.71573,16.73,0.6283818,296.88157,38.009987
2023-12-27T00:00Z,55.50766,-61.60096,16.742,0.6227852,298.16471,38.288434
2023-12-28T00:00Z,55.0507,-61.48232,16.754,0.6172198,299.44229,38.562824
2023-12-29T00:00Z,54.60517,-61.35996,16.765,0.6116867,300.71449,38.833103
2023-12-30T00:00Z,54.17109,-61.23404,16.777,0.6061866,301.98145,39.099227
2023-12-31T00:00Z,53.74849,-61.10472,16.789,0.6007202,303.24331,39.361151`;

export const ephemerisCometImageDatesCsv = `Date,RA,Dec,Tmag
2022-12-18T00:00Z,238.40594,26.96089,11.566
2022-12-27T00:00Z,238.40455,29.22353,11.112
2022-12-28T00:00Z,238.38676,29.55233,11.056
2022-12-29T00:00Z,238.36422,29.90066,10.999
2023-01-01T00:00Z,238.26346,31.07842,10.82
2023-01-02T00:00Z,238.21696,31.52137,10.757
2023-01-11T00:00Z,237.3198,37.19703,10.106
2023-01-14T00:00Z,236.67834,40.1378,9.846
2023-01-20T00:00Z,233.98884,49.11466,9.238
2023-01-24T00:00Z,226.84037,62.19105,9.983
2023-01-29T00:00Z,174.79061,79.78143,9.594
2023-02-05T00:00Z,77.60624,47.88033,8.329
2023-02-06T00:00Z,75.90330,42.77576,10.098
2023-02-07T00:00Z,74.66152,38.32805,8.329
2023-02-08T00:00Z,73.57624,33.82034,8.329
2023-02-09T00:00Z,72.79050,30.12149,8.329`;

